<template>
  <li
    v-ripple
    class="related-hat"
    @click="goToHat(hatData)">
    <div class="related-hat__image-wrapper">
      <img
        v-if="hatData.images"
        :src="imageDir + hatData.images[0]"
        class="related-hat__image">
    </div>
    <div class="related-hat__name">
      {{ hatData.name }}
    </div>
  </li>
</template>

<script>
import api from '../utils/api';

export default {
  name: 'RelatedHat',
  props: {
    hatSlug: String,
  },
  data() {
    return {
      loading: false,
      errorMessage: '',
      hatData: {},
    };
  },
  computed: {
    imageDir() {
      return this.$store.state.hats.imageDir;
    },
  },
  created() {
    this.loading = true;
    api
      .getData(`/hats/${this.hatSlug}`)
      .then((res) => {
        this.hatData = res.data;
        this.loading = false;
      })
      .catch((error) => {
        this.errorMessage = error;
        this.loading = false;
      });
  },
  methods: {
    goToHat(item) {
      this.$router.push({
        name: 'hat-product',
        params: {
          id: item.id,
          slug: item.slug,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.related-hat
  position: relative
  display: flex
  flex-flow: column nowrap
  align-items:center
  justify-content: flex-start
  padding: $base-padding*.5
  list-style: none
  border-radius: $base-border-radius
  &::before
    content: ''
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    z-index: 1
    background-color: $white
    opacity: 0
    transition: $base-transition
    cursor: pointer
  &:hover::before
    opacity: .24

  &__image
    max-width: 100%

  &__name
    font-size: .85rem
    text-transform: capitalize
    text-align: center
    padding-top: $base-padding*.5

</style>
